<script lang="ts">
  import * as _ from "lodash";
  export let selectDistributor: (distributor: any) => void;
  export let page = null;

  // stores
  import { DistributorStore } from "@distributor/svelte/Stores/DistributorStore";

  let distributors;

  // functions
  const chooseDistributor = event => {
    currentDistributor = _.find(distributors, { distributor_id: parseInt(event.target.value) });
    selectDistributor(currentDistributor.distributor_id);
  };

  const setDistributors = (path, distributorsFromStore) => {
    if (path === "/distributor/payments/index") {
      distributors = distributorsFromStore?.filter(d => d.uses_term_payments);
    } else {
      distributors = distributorsFromStore;
    }
  };

  // reactives
  $: currentDistributor = $DistributorStore.currentDistributor;
  $: setDistributors($page?.path, $DistributorStore.distributors);
</script>

<style lang="scss">
  .gray-600 {
    background-color: #595959;
  }
  .responsive-width {
    @media (min-width: 768px) {
      width: 20%;
    }
  }
</style>

{#if currentDistributor}
  <div class="gray-600 fizz-flex-row-8-responsive fizz-justify-end fizz-inset-square-8">
    <p class="fizz-label fizz-text-inverse">Select Distributor</p>
    <select
      id="distributorSelector"
      class="fizz-select fizz-full-width responsive-width fizz-text-strong"
      name="distributorSelector"
      value={currentDistributor.distributor_id}
      on:change={chooseDistributor}
      on:blur={() => {}}
    >
      {#each distributors as distributor}
        <option value={distributor.distributor_id}>{distributor.name}</option>
      {/each}
    </select>
  </div>
{/if}
